import { DropdownInputGroup, FieldType } from "@typedefs/modulesInterfaces";
import { useContextAwareGetAllTags } from "@hooks/index";
import { useMemo } from "react";
import GenericInputGroup from "@components/input/inputGroup/GenericInputGroup";
import TranslatableText from "@components/translations/TranslatableText";
import Spinner from "@components/spinner/Spinner";
import useErrorMessage from "@utils/useErrorMessage";

const SearchByTag = () => {
  const { data: tags, isLoading: isLoadingTags, isError, error } = useContextAwareGetAllTags();
  const { errorMsg } = useErrorMessage({ isError, error });

  const searchInput: DropdownInputGroup = useMemo(() => ({
    type: FieldType.SELECT,
    inputName: "tags",
    label: "project.search_by_tag",
    dropdownOptions: tags ?? [],
    isMulti: true,
    showComments: false,
  }), [tags]);

  return (
    <section className="d-flex f-column gap-8">
      <div className="d-flex f-column gap-8" style={{ maxWidth: "400px" }}>
        <TranslatableText
          className="fs-11"
          translationKey="project.search_by_tag"
          style={{
            color: "var(--dark-gray)",
            fontWeight: "500"
          }}
        />
        {isLoadingTags ? (
          <div className="d-flex align-items-center">
            <Spinner size={16} isBlack />
          </div>
        ) : errorMsg ?
          <span className="error fs-13 pb-2">
            {errorMsg}
          </span>
          : (
            <GenericInputGroup inputGroup={{ ...searchInput, disabled: isLoadingTags }} />
          )}
      </div>
    </section>
  );
}

export default SearchByTag;